import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconSpinner: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <circle cx="8" cy="8" r="6" strokeOpacity="0.25" />
    <path d="M14 8A6 6 0 0 0 8 2" />
  </svg>
);

export {
  IconSpinner,
};
